import React from 'react';
import { WrenchIcon, PiggyBankIcon, CalendarClockIcon, ShieldCheckIcon, EyeOffIcon, FileTextIcon, ClockIcon, BoxIcon } from 'lucide-react';
const benefits = [{
  icon: WrenchIcon,
  title: 'Sell As-Is',
  description: "Don't spend a dime on repairs. We buy houses in any condition, even if they need major work."
}, {
  icon: PiggyBankIcon,
  title: 'No Agent Commissions',
  description: 'Keep more money in your pocket. You pay zero real estate agent fees or hidden costs.'
}, {
  icon: EyeOffIcon,
  title: 'Avoid Showings',
  description: 'No open houses, no strangers walking through your home, and no keeping it perfectly clean.'
}, {
  icon: CalendarClockIcon,
  title: 'Close in Days',
  description: 'Skip the months of waiting. We can close in as little as 7 days, or on your exact schedule.'
}, {
  icon: FileTextIcon,
  title: 'We Handle Everything',
  description: 'From the paperwork to the title company, our team manages the entire process for you.'
}, {
  icon: ShieldCheckIcon,
  title: 'Guaranteed Offer',
  description: 'Unlike traditional buyers whose financing can fall through, our cash offers are guaranteed.'
}];
export function BenefitsSection() {
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16 bg-slate-50" data-id="element-4">
      <div className="max-w-7xl mx-auto" data-id="element-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-6">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1" data-id="element-7">
            <div className="absolute -inset-4 bg-[#0F172A]/5 rounded-3xl transform -rotate-2" data-id="element-8" />
            <div className="absolute -inset-4 bg-[#D4A24C]/10 rounded-3xl transform rotate-2" data-id="element-9" />
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-10">
              <img src="https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&w=2000&q=80" alt="Classic American single-family home" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-11" />
              {/* Overlay Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-white/20 flex items-center gap-4" data-id="element-12">
                <div className="w-12 h-12 bg-[#D4A24C]/10 rounded-full flex items-center justify-center shrink-0" data-id="element-13">
                  <ShieldCheckIcon className="w-6 h-6 text-[#D4A24C]" data-id="element-14" />
                </div>
                <div data-id="element-15">
                  <p className="font-bold text-[#0F172A]" data-id="element-16">
                    Guaranteed Cash Offer
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-17">
                    No financing fall-throughs
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2" data-id="element-18">
            <div className="mb-10" data-id="element-19">
              <span className="text-xs font-bold text-[#D4A24C] uppercase tracking-widest mb-3 block" data-id="element-20">
                The Nationwide Home Buyers Advantage
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-6 tracking-tight" data-id="element-21">
                A Better Way to Sell Your House
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-22">
                Traditional real estate sales are stressful, time-consuming, and
                expensive. We've simplified the process so you can sell your
                house quickly and move on with your life.
              </p>
            </div>

            <div className="space-y-8" data-id="element-23">
              {[{
              icon: BoxIcon,
              title: 'Zero Fees or Commissions',
              desc: "What we offer is what you get. We don't charge any agent fees, commissions, or hidden costs."
            }, {
              icon: ClockIcon,
              title: 'Close When You Want',
              desc: 'Need to close in 7 days? We can do that. Need 2 months to pack? That works too. You pick the date.'
            }, {
              icon: WrenchIcon,
              title: 'No Repairs Needed',
              desc: 'We buy houses strictly as-is. Leave the leaky roof, the ugly carpet, and even the stuff you don’t want to pack.'
            }].map(({
              icon: Icon,
              title,
              desc
            }) => <div key={title} className="flex gap-4" data-id="element-24">
                  <div className="mt-1" data-id="element-25">
                    <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-slate-100 flex items-center justify-center" data-id="element-26">
                      <Icon className="w-6 h-6 text-[#D4A24C] shrink-0 mt-0.5" data-id="element-27" />
                    </div>
                  </div>
                  <div data-id="element-28">
                    <h3 className="text-xl font-bold text-[#0F172A] mb-1.5" data-id="element-29">
                      {title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed" data-id="element-30">{desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}